import { cn } from "@/utils/cn";
import { ButtonHTMLAttributes } from "react";

type PillButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  selected?: boolean;
};

export function PillButton({
  selected = false,
  className,
  children,
  type = "button",
  ...props
}: PillButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        "rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 ease-out",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "border border-transparent bg-white",
        {
          "border-black hover:bg-black/10 active:bg-black/10": !selected,
          "bg-button-black-default active:bg-button-black-active hover:bg-button-black-active disabled:text-button-black-disabled text-white hover:opacity-90":
            selected,
        },
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
